import { FaBars } from 'react-icons/fa';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
  
export const Nav = styled.nav`
  color: #1D1D1F;
  background:#FFFFFFCC;
  height: 48px;
  backdrop-filter: saturate(180%) blur(20px);
  position:fixed;
  right:0;
  left:0;
  top:0;
  max-height: 44px
  align-items: end;
  user-select: none;
  margin: 0px;
  display: flex;
  width: 100%;
  justify-content: end;
  z-index: 1000;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;
  
export const NavLink = styled(Link)`
  color: #000;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 16px;
  height: 100%;
  font-size: 14px;
  cursor: pointer;
`;
  
export const Bars = styled(FaBars)`
  display: none;
  color: #000;
  @media screen and (max-width: 738px) {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(100%, 100%);
    font-size: 17px;
    cursor: pointer;
  }
`;



export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    left: 0;
    color: #000;
    background:transparent;
    font-size: 17px;
    transform: translate(100%, 100%);
    cursor:pointer;
    outline:none;
`;
  
export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  /* Second Nav */
  /* margin-right: 24px; */
  /* Third Nav */
  /* width: 100vw;
  white-space: nowrap; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
  